import { render, staticRenderFns } from "./receiptRecording.vue?vue&type=template&id=695e986d&scoped=true"
import script from "./receiptRecording.vue?vue&type=script&lang=js"
export * from "./receiptRecording.vue?vue&type=script&lang=js"
import style0 from "./receiptRecording.vue?vue&type=style&index=0&id=695e986d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695e986d",
  null
  
)

export default component.exports